export default __webpack_public_path__ + "static/social-anomalias-16abce61453729fb3d8ec7d53332d0a8.png";